import { render, staticRenderFns } from "./SpinnerAsistencia.vue?vue&type=template&id=4a53af30&scoped=true&"
import script from "./SpinnerAsistencia.vue?vue&type=script&lang=js&"
export * from "./SpinnerAsistencia.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerAsistencia.vue?vue&type=style&index=0&id=4a53af30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a53af30",
  null
  
)

export default component.exports